const $6401b53bf7af177a$var$DEFAULT_SETTINGS = {
    arrowSize: 10,
    crossSize: 12,
    thickArrowSize: 30,
    labelOffset: 10,
    corruptStart: 0.85,
    dropStart: 0.85,
    squiggleSize: 20,
    squiggleCount: 2,
    messageSpacingY: 40,
    participantSpacingX: 240,
    participantLabelHeight: 30,
    annotationSpacingX: 80,
    participantFontSize: 20,
    messageFontSize: 15,
    paddingX: 30,
    paddingY: 20
};
function $6401b53bf7af177a$export$98e6a39c04603d36(src) {
    const settings = $6401b53bf7af177a$var$DEFAULT_SETTINGS;
    const participants = [];
    const actions = [];
    let numAnnotations = 0;
    const lines = src.split("\n");
    for (let line of lines){
        line = line.trim();
        if (!line || line.startsWith("//")) continue;
        // overwrite default settings
        if (line.startsWith("def")) {
            const [, name, value] = line.split(/\s+/);
            settings[name] = parseFloat(value);
            continue;
        }
        // participants
        // /^participant\s+((?:["'][^"'@]+["'])|[^\s"'@]+)\s+([^\s"'@]+)/
        if (line.startsWith("participant")) {
            const [, name, alias] = line.split(/\s+/);
            participants.push({
                name: name,
                alias: alias,
                column: participants.length
            });
            continue;
        }
        // annotations
        const annMatch = line.match(/^(\w+)(?:\s*@([\d.]+))?\s*([<>])\s*"(.+)"/);
        if (annMatch) {
            numAnnotations++;
            actions.push({
                type: "annotation",
                participant: annMatch[1],
                height: annMatch[2] ? parseFloat(annMatch[2]) : undefined,
                side: annMatch[3] === "<" ? "left" : "right",
                text: annMatch[4]
            });
            continue;
        }
        // arrows
        const arrowMatch = line.match(/^(\w+)(?:\s*@([\d.]+))?\s*(->|=>|~>|-x)\s*(\w+)(?:\s*@([\d.]+))?(?:\s*:\s*"(.+)")?/);
        if (arrowMatch) {
            const typeMap = {
                "->": "normal",
                "=>": "thick",
                "~>": "corrupt",
                "-x": "dropped"
            };
            actions.push({
                type: "arrow",
                from: arrowMatch[1],
                start: arrowMatch[2] ? parseFloat(arrowMatch[2]) : undefined,
                arrowType: typeMap[arrowMatch[3]],
                to: arrowMatch[4],
                end: arrowMatch[5] ? parseFloat(arrowMatch[5]) : undefined,
                label: arrowMatch[6]
            });
            continue;
        }
    }
    return {
        settings: settings,
        participants: participants,
        actions: actions,
        numAnnotations: numAnnotations
    };
}


function $f82b67f096a9a947$export$3bdb645cfef508e8(entities) {
    const { settings: settings, participants: participants, actions: actions, numAnnotations: numAnnotations } = entities;
    // 1. check if need extra spacing for annotations
    let width = settings.participantSpacingX * (participants.length - 1) + 2 * settings.paddingX;
    if (numAnnotations > 0) width += 2 * settings.annotationSpacingX;
    // 2. figure out top spacing for participant label and padding
    let height = settings.paddingX + settings.participantLabelHeight + settings.messageSpacingY; // last one is a hack
    // 3. resolve participant x position
    const participantsX = new Map(); // map alias -> x coord
    {
        // recomputing width, but whatever
        let x = settings.paddingX + (numAnnotations > 0 ? settings.annotationSpacingX : 0);
        for (const participant of participants){
            participantsX.set(participant.alias, x);
            x += settings.participantSpacingX;
        }
    }
    // 4. resolve arrows and annotations
    let counter = 0, counterMax = counter;
    const draws = [];
    for (const action of actions){
        switch(action.type){
            case "arrow":
                // @ positioning on the source should modify the counter
                let startY = counter;
                let endY = counter + 1;
                if (action.start) {
                    counter = action.start;
                    startY = counter;
                    endY = counter + 1;
                }
                if (action.end) endY = action.end;
                draws.push({
                    type: action.type,
                    x1: participantsX.get(action.from),
                    y1: height + startY * settings.messageSpacingY,
                    x2: participantsX.get(action.to),
                    y2: height + endY * settings.messageSpacingY,
                    arrowType: action.arrowType,
                    label: action.label
                });
                counter++;
                break;
            case "annotation":
                // @ positioning should just position and nothing else
                let y = counter;
                if (action.height) y = action.height;
                draws.push({
                    type: action.type,
                    x: participantsX.get(action.participant) - (action.side == "left" ? 1 : -1) * (settings.annotationSpacingX / 2),
                    y: height + y * settings.messageSpacingY,
                    align: action.side == "left" ? "right" : "left",
                    text: action.text
                });
                break;
        }
        counterMax = Math.max(counterMax, counter);
    }
    // 5. resolve height of participant lifetimes
    // draws.reverse(); // TBC: might look better if one rendered above
    const oldHeight = height - settings.messageSpacingY; // another hack
    height += (counterMax + 1) * settings.messageSpacingY; // add some extra length to the lifetime
    const lifelines = participants.map((p)=>{
        return {
            type: "participant",
            x: participantsX.get(p.alias),
            y1: oldHeight,
            y2: height,
            name: p.name
        };
    });
    height += settings.paddingY;
    return {
        settings: settings,
        width: width,
        height: height,
        draws: [
            ...lifelines,
            ...draws
        ]
    };
}


function $621f3774f67738fc$var$drawParticipant(settings, participant) {
    const { x: x, y1: y1, y2: y2, name: name } = participant;
    return `
<text
  x="${x}"
  y="${y1 - settings.participantLabelHeight / 2}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.participantFontSize}"
>
  ${name}
</text>
<line stroke="#aaaaaa" x1="${x}" y1="${y1}" x2="${x}" y2="${y2}" />`;
}
function $621f3774f67738fc$var$drawAnnotation(settings, annotation) {
    const { x: x, y: y, align: align, text: text } = annotation;
    // TODO: handle align and wrapping
    return `
<text
  x="${x}"
  y="${y}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  fill="white"
  font-size="${settings.messageFontSize}"
>
  ${text}
</text>`;
}
function $621f3774f67738fc$var$drawArrow(settings, arrow) {
    const { x1: x1, y1: y1, x2: x2, y2: y2, arrowType: arrowType, label: label } = arrow;
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.hypot(dx, dy);
    // normalized
    const ux = dx / len;
    const uy = dy / len;
    // normalized perpendicular
    const px = -uy;
    const py = ux;
    // arrow
    let arrowsvg = '';
    // arrow head
    const baseX = x2 - ux * settings.arrowSize;
    const baseY = y2 - uy * settings.arrowSize;
    const leftX = baseX + px * settings.arrowSize * 0.5;
    const leftY = baseY + py * settings.arrowSize * 0.5;
    const rightX = baseX - px * settings.arrowSize * 0.5;
    const rightY = baseY - py * settings.arrowSize * 0.5;
    switch(arrowType){
        case "normal":
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" />
  <line x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
</g>`;
            break;
        case "dropped":
            // cross
            const dropX = x1 + ux * len * settings.dropStart;
            const dropY = y1 + uy * len * settings.dropStart;
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <line x1="${x1}" y1="${y1}" x2="${dropX}" y2="${dropY}" />
  <line stroke="red" x1="${dropX - settings.crossSize * 0.5}" y1="${dropY - settings.crossSize * 0.5}" x2="${dropX + settings.crossSize * 0.5}" y2="${dropY + settings.crossSize * 0.5}" />
  <line stroke="red" x1="${dropX - settings.crossSize * 0.5}" y1="${dropY + settings.crossSize * 0.5}" x2="${dropX + settings.crossSize * 0.5}" y2="${dropY - settings.crossSize * 0.5}" />
</g>`;
            break;
        case "corrupt":
            // draw the squiggly
            const waveX = x1 + ux * len * settings.corruptStart;
            const waveY = y1 + uy * len * settings.corruptStart;
            const waveLen = len * (1 - settings.corruptStart) - 2 * settings.arrowSize;
            const waveInterval = waveLen / (4 * settings.squiggleCount);
            let path = '';
            let sx = waveX;
            let sy = waveY;
            for(let i = 0; i < settings.squiggleCount; i++){
                sx += ux * waveInterval;
                sy += uy * waveInterval;
                path += `L ${sx - px * settings.squiggleSize * 0.5} ${sy - py * settings.squiggleSize * 0.5} `;
                sx += 2 * ux * waveInterval;
                sy += 2 * uy * waveInterval;
                path += `L ${sx + px * settings.squiggleSize * 0.5} ${sy + py * settings.squiggleSize * 0.5} `;
                sx += ux * waveInterval;
                sy += uy * waveInterval;
            }
            sx += ux * waveInterval;
            sy += uy * waveInterval;
            path += `L ${sx} ${sy}`;
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <line x1="${x1}" y1="${y1}" x2="${waveX}" y2="${waveY}" />
  <path stroke="orange" d="M ${waveX} ${waveY} ${path} L ${baseX} ${baseY}" />
  <line stroke="orange" x1="${baseX}" y1="${baseY}" x2="${x2}" y2="${y2}" />
  <line stroke="orange" x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line stroke="orange" x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
</g>`;
            break;
        case "thick":
            arrowsvg = `
<g stroke="white" stroke-width="2" fill="none" stroke-linecap="round">
  <polygon stroke="none" fill="#ffffff44" points="${x1},${y1} ${x2},${y2} ${x2},${y2 + settings.thickArrowSize} ${x1},${y1 + settings.thickArrowSize}" />
  <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" />
  <line x1="${x2}" y1="${y2}" x2="${leftX}" y2="${leftY}" />
  <line x1="${x2}" y1="${y2}" x2="${rightX}" y2="${rightY}" />
  <line x1="${x1}" y1="${y1 + settings.thickArrowSize}" x2="${x2}" y2="${y2 + settings.thickArrowSize}" />
  <line x1="${x2}" y1="${y2 + settings.thickArrowSize}" x2="${leftX}" y2="${leftY + settings.thickArrowSize}" />
  <line x1="${x2}" y1="${y2 + settings.thickArrowSize}" x2="${rightX}" y2="${rightY + settings.thickArrowSize}" />
</g>`;
            break;
    }
    // label
    let labelsvg = '';
    if (label) {
        const mx = (x1 + x2) / 2;
        const my = (y1 + y2) / 2;
        let offset = settings.labelOffset;
        let direction = 1;
        let angle = Math.atan2(dy, dx) * 180 / Math.PI;
        if (angle > 90 || angle < -90) {
            angle += 180;
            direction = -1;
            offset *= direction;
        }
        const lx = mx - px * offset;
        const ly = arrowType === "thick" ? my + direction * py * settings.thickArrowSize / 2 : my - py * offset;
        labelsvg = `
<text
  x="${lx}"
  y="${ly}"
  text-anchor="middle"
  dominant-baseline="middle"
  font-family="JetBrains Mono, monospace"
  transform="rotate(${angle} ${lx} ${ly})"
  fill="white"
  font-size="${settings.messageFontSize}"
>
  ${label}
</text>`;
    }
    return `${arrowsvg}${labelsvg}`;
}
function $621f3774f67738fc$export$c5f8399d19a7394b(entities) {
    const { settings: settings, width: width, height: height, draws: draws } = (0, $f82b67f096a9a947$export$3bdb645cfef508e8)(entities);
    let svg = [];
    svg.push(`<svg class="protocol-diagram" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">`);
    svg.push(`<rect width="100%" height="100%" fill="#333333"/>`);
    for (const draw of draws)switch(draw.type){
        case "participant":
            svg.push($621f3774f67738fc$var$drawParticipant(settings, draw));
            break;
        case "arrow":
            svg.push($621f3774f67738fc$var$drawArrow(settings, draw));
            break;
        case "annotation":
            svg.push($621f3774f67738fc$var$drawAnnotation(settings, draw));
            break;
    }
    //   svg.push(`<line
    //   x1=50
    //   y1=0
    //   x2=50
    //   y2=480
    //   stroke="#eeeeee"
    //   stroke-width=1
    // />
    // <line
    //   x1=330
    //   y1=0
    //   x2=330
    //   y2=480
    //   stroke="#eeeeee"
    //   stroke-width=1
    // />`);
    // svg.push(drawArrow("normal", 50, 50, 510, 100, "hello"));
    // svg.push(drawArrow("dropped", 510, 100, 50, 200, "hello indeed"));
    // svg.push(drawArrow("corrupt", 50, 200, 510, 300, "why u blue tick me?"));
    // svg.push(drawArrow("thick", 510, 300, 50, 430, "chonk"));
    //
    svg.push(`</svg>`);
    return svg.join("\n");
}


const $ea35524f8b95a2a5$var$preview = document.getElementById('preview');
const $ea35524f8b95a2a5$var$copyCodeBtn = document.getElementById('copyCode');
const $ea35524f8b95a2a5$var$copyPNGBtn = document.getElementById('copyPNG');
const $ea35524f8b95a2a5$var$copySVGBtn = document.getElementById('copySVG');
const $ea35524f8b95a2a5$var$INITIAL_CODE = `def messageSpacing 20px
def participantSpacing 160px

participant Alice a
participant Bob b

a -> b : "normal"
b -> a : "normal reply"

a ~> b : "corrupted"
b ~> a : "corrupted reply"

a -x b : "dropped"
b -x a : "dropped reply"

a => b : "thick"
b => a : "thick reply"

a @2 < "left label @2"
b @5 > "right label @5"`;
const $ea35524f8b95a2a5$var$editor = window.CodeMirror(document.getElementById('editor'), {
    value: $ea35524f8b95a2a5$var$INITIAL_CODE,
    mode: 'protocol-ml',
    lineNumbers: true,
    autofocus: true,
    tabSize: 2,
    indentUnit: 2,
    viewportMargin: Infinity
});
let $ea35524f8b95a2a5$var$currentSVG = '';
function $ea35524f8b95a2a5$var$render() {
    const code = $ea35524f8b95a2a5$var$editor.getValue();
    try {
        const diagram = (0, $6401b53bf7af177a$export$98e6a39c04603d36)(code);
        $ea35524f8b95a2a5$var$currentSVG = (0, $621f3774f67738fc$export$c5f8399d19a7394b)(diagram);
        $ea35524f8b95a2a5$var$preview.innerHTML = `<div class="protocol-ml-wrapper">${$ea35524f8b95a2a5$var$currentSVG}</div>`;
    } catch (err) {
        $ea35524f8b95a2a5$var$preview.innerHTML = `<div class="error">Error: ${err.message}</div>`;
        $ea35524f8b95a2a5$var$currentSVG = '';
    }
}
// Debounce rendering for performance
let $ea35524f8b95a2a5$var$renderTimeout;
$ea35524f8b95a2a5$var$editor.on('change', ()=>{
    clearTimeout($ea35524f8b95a2a5$var$renderTimeout);
    $ea35524f8b95a2a5$var$renderTimeout = setTimeout($ea35524f8b95a2a5$var$render, 300);
});
$ea35524f8b95a2a5$var$copyCodeBtn.addEventListener('click', async ()=>{
    try {
        await navigator.clipboard.writeText($ea35524f8b95a2a5$var$editor.getValue());
        $ea35524f8b95a2a5$var$copyCodeBtn.textContent = 'Copied!';
        $ea35524f8b95a2a5$var$copyCodeBtn.classList.add('copied');
        setTimeout(()=>{
            $ea35524f8b95a2a5$var$copyCodeBtn.textContent = 'Copy Code';
            $ea35524f8b95a2a5$var$copyCodeBtn.classList.remove('copied');
        }, 2000);
    } catch (err) {
        console.error('Failed to copy:', err);
    }
});
$ea35524f8b95a2a5$var$copyPNGBtn.addEventListener('click', async ()=>{
    if (!$ea35524f8b95a2a5$var$currentSVG) return;
    try {
        const svgElement = $ea35524f8b95a2a5$var$preview.querySelector('svg');
        if (!svgElement) return;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const svgData = new XMLSerializer().serializeToString(svgElement);
        canvas.width = svgElement.width.baseVal.value;
        canvas.height = svgElement.height.baseVal.value;
        const img = new Image();
        const svgBlob = new Blob([
            svgData
        ], {
            type: 'image/svg+xml;charset=utf-8'
        });
        const url = URL.createObjectURL(svgBlob);
        img.onload = async ()=>{
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            canvas.toBlob(async (blob)=>{
                try {
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            'image/png': blob
                        })
                    ]);
                    $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copied!';
                    $ea35524f8b95a2a5$var$copyPNGBtn.classList.add('copied');
                    setTimeout(()=>{
                        $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copy PNG';
                        $ea35524f8b95a2a5$var$copyPNGBtn.classList.remove('copied');
                    }, 2000);
                } catch (err) {
                    console.error('Failed to copy PNG:', err);
                    $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Failed';
                    setTimeout(()=>{
                        $ea35524f8b95a2a5$var$copyPNGBtn.textContent = 'Copy PNG';
                    }, 2000);
                }
            }, 'image/png');
        };
        img.onerror = ()=>{
            console.error('Failed to load SVG');
            URL.revokeObjectURL(url);
        };
        img.src = url;
    } catch (err) {
        console.error('Failed to copy PNG:', err);
    }
});
$ea35524f8b95a2a5$var$copySVGBtn.addEventListener('click', async ()=>{
    if (!$ea35524f8b95a2a5$var$currentSVG) return;
    try {
        await navigator.clipboard.writeText($ea35524f8b95a2a5$var$currentSVG);
        $ea35524f8b95a2a5$var$copySVGBtn.textContent = 'Copied!';
        $ea35524f8b95a2a5$var$copySVGBtn.classList.add('copied');
        setTimeout(()=>{
            $ea35524f8b95a2a5$var$copySVGBtn.textContent = 'Copy SVG';
            $ea35524f8b95a2a5$var$copySVGBtn.classList.remove('copied');
        }, 2000);
    } catch (err) {
        console.error('Failed to copy:', err);
    }
});
// Initial render
$ea35524f8b95a2a5$var$render();


//# sourceMappingURL=docs.daa31e65.js.map
